import { useContext } from 'react';
import { InsightContext, LangContext, NewsContext, PageContext, PageType } from '../../../App';
import RedArrowRight from '../../../assets/icons/arrow-right-red.svg';

type BlogCardVertical = {
    title : string;
    description : string;
    sectionIndex : number;
    image : {
        src : string;
        alt : string;
    },
    button? : {
        text : string;
        path : PageType;
    },
    page : string;
    articleIndex : number;
}

const BlogCardVertical = ({
    title,
    description,
    sectionIndex,
    image,
    articleIndex,
    page,
} : BlogCardVertical ) => {
    const { lang } = useContext(LangContext);

    const { handleChangeCurrentNewsData } = useContext(NewsContext);
    const { handleChangeCurrentInsightData } = useContext(InsightContext);

  return (
    <div className="blog-card-vertical">
        <div className="card-header">
            <img 
                src={image.src}
                alt={image.alt}
                className="card-image"
            />
        </div>
        <div className="card-body">
            <h3 className="card-title">{title}</h3>
            <p className="card-subtitle">{description}</p>
            <button 
                type="button"
                className="card-button"
                title={`${lang ? "View more about" : "أقرأ المزيد عن "} ${title}`}
                aria-label={`${lang ? "View more about" : "أقرأ المزيد عن "} ${title}`}
                onClick={() => {
                    if (page === "news") {
                        handleChangeCurrentNewsData(sectionIndex, articleIndex)
                    } else {
                        handleChangeCurrentInsightData(articleIndex);
                    }
                }}
            >
                <span>{!lang ? "Read More" : "أقرأ المزيد"}</span>
                <span>
                    <img 
                        src={RedArrowRight}
                        alt=""
                        aria-hidden="true"
                        className={`arrow-right-icon ${lang === 0 ? "" : "rtl"}`}
                    />
                </span>
            </button>
        </div>
    </div>
  )
}

export default BlogCardVertical